import React,{useState,useEffect} from 'react';
import { Link,useParams } from 'react-router-dom';
import MetaData from '../components/MetaData.js';
import { useSelector, useDispatch } from "react-redux";
import { clearErrors, getProduct, getProductByCate } from "../actions/productAction";
import { getAllCategories } from "../actions/categoryAction";
import Loader from "../components/Loader.js";
import { useAlert } from "react-alert";
import Pagination from "react-js-pagination";
import Slider from "@material-ui/core/Slider";

// const categories = [
//   "wall-tiles",
//   "floor-tiles",
//   "bathroom-tiles",
//   "outdoor-tiles",
//   "brick-&-metro tiles",
//   "mosaic-tiles",
// ];

const ShopByCate = () => {

    const alert = useAlert();
    const dispatch = useDispatch();
    const [currentPage, setCurrentPage] = useState(1);
    const [price, setPrice] = useState([0, 999]);
    const [cate, setCate] = useState("");
    const [speaker, setSpeaker] = useState("");
    const [ratings, setRatings] = useState(0);
    const [active, setActive] = useState(null);
    const [activeSpeaker, setActiveSpeaker] = useState(null);

    const {
    products,
    loading,
    error,
    productsCount,
    resultPerPage,
    filteredProductsCount,
  } = useSelector((state) => state.products);

  const { categories } = useSelector((state) => state.categories);

    const { category } = useParams();
    const  {keyword}  = useParams();
    const setCurrentPageNo = (e) => {
        setCurrentPage(e);
    };

    const priceHandler = (event, newPrice) => {
        setPrice(newPrice);
    };

    // useEffect(() => {
    //     if (error) {
    //       alert.error(error);
    //       dispatch(clearErrors());
    //     }
    //     dispatch(getProductByCate(category))
    //     dispatch(getAllCategories());
    // }, [dispatch, category, error, alert]);

    let count = filteredProductsCount;

    useEffect(() => {
    const fetchProducts = async () => {
        try {
            if (error) {
                alert.error(error);
                dispatch(clearErrors());
                return; // Exit early if there's an error
            }

            // Fetch products by category with applied filters
            await dispatch(getProductByCate(keyword, currentPage, price, category, ratings, speaker));
        } catch (err) {
            console.error("Error fetching products or applying filters:", err);
        }
    };

    fetchProducts();
}, [dispatch, keyword, category, price, currentPage, ratings, speaker, error, alert]);

	return (

        <>

        
        <MetaData title="Courses" />
			
			

    

    {/*<!-- Shop Section Start -->*/}
    <div className="section section-padding">
        <div className="container">
            {/*<!-- Product Section Wrapper Start -->*/}
            <div className="product-section-wrapper" style={{marginTop: '0px'}}>
                <div className="row flex-row-reverse">
                    <div className="col-lg-9">
                        {/*<!-- Shop top Bar Start -->*/}
                        <div className="shop-top-bar">
                            <div className="shop-text">
                                <p>
                                    {category} Courses
                                </p>
                            </div>
                            <div className="shop-tabs">
                                <ul className="nav">
                                    <li>
                                        <button className="active" data-bs-toggle="tab" data-bs-target="#grid">
                                            <i className="fa fa-th"></i>
                                        </button>
                                    </li>
                                    <li>
                                        <button data-bs-toggle="tab" data-bs-target="#list">
                                            <i className="fa fa-list"></i>
                                        </button>
                                    </li>
                                </ul>
                            </div>
                            {/*<div className="shop-sort">
                                <span className="title">Sort By :</span>
                                <select className="select2-2">
                                    <option value="featured">
                                        Featured
                                    </option>
                                    <option value="rating">Rating</option>
                                    <option value="price">Price</option>
                                </select>
                            </div>*/}
                        </div>
                        {/*<!-- Shop top Bar End -->*/}
                        
                        <div className="tab-content">
                            <div className="tab-pane fade show active" id="grid">
                                {/*<!-- Shop Product Wrapper Start -->*/}
                                {
            loading? ( <Loader />) :(
        <>
                                <div className="shop-product-wrapper">
                                    <div className="row">
                                    {
                                        products && products.map((product) =>{
                                            return(

                                                <div key={product._id} className="col-md-6 col-sm-6 col-12">
                                                   <div className="elearningCourses">
                                                    <div className='single-product'>
                                        <div className='product-image'>
                                          <Link to={`/product/${product._id}`}>
                                            <img src={product.images[0].url} alt={product.name}/>
                                          </Link>
                                        </div>
                                        <div className='product-content'>
                                          <h4 className='title'>
                                            <Link to={`/product/${product._id}`}>
                                              {product?.name
                                                ?.split(" ")
                                                .slice(0, 7)
                                                .join(" ") + (product?.name?.split(" ").length > 7 ? "..." : "")}
                                            </Link>
                                          </h4>
                                          <div className="courseContent"
                                            dangerouslySetInnerHTML={{
                                              __html: product?.description
                                                ?.split(" ")
                                                .slice(0, 10)
                                                .join(" ") + (product?.description?.split(" ").length > 10 ? "..." : ""),
                                            }}
                                          ></div>
                                          <Link className='action btn btn-primary' to={`/product/${product._id}`}>
                                            <span>See Details</span>
                                          </Link>
                                        </div>
                                        {/*<div className="product-content backContent">
                                          <div
                                                                    dangerouslySetInnerHTML={{
                                                                      __html: product?.description
                                                                        ?.split(" ")
                                                                        .slice(0, 20)
                                                                        .join(" ") + (product?.description?.split(" ").length > 10 ? "..." : ""),
                                                                    }}
                                                                  ></div>
                                          <ul className='product-meta'>
                                            <li>
                                              <Link className='action' to={`/product/${product._id}`}>
                                                <span>See Details</span>
                                              </Link>
                                            </li>
                                          </ul>
                                        </div>*/}
                                      </div>
                                                </div>
                                                </div>

                                                )
                                            
                                        })
                                    }
                                        
                                    </div>
                                </div>

                                </>
     )
        }
                                {/*<!-- Shop Product Wrapper End -->*/}

                            </div>
                            <div className="tab-pane fade" id="list">
                                {/*<!-- Shop Product Wrapper Start -->*/}
                                {
            loading? ( <Loader />) :(
        <>
                                <div className="shop-product-wrapper">
                                <div className="row">
                                    {/*<!-- Single Product Start -->*/}
                                    {
                                        products && products.map((product) =>{
                                            return(    

                                                    <div key={product._id} className="col-md-6 col-sm-6 col-12">
                                                        <div className="elearningCourses">
                                                    <div className='single-product'>
                                        <div className='product-image'>
                                          <Link to={`/product/${product._id}`}>
                                            <img src={product.images[0].url} alt={product.name}/>
                                          </Link>
                                        </div>
                                        <div className='product-content'>
                                          <h4 className='title'>
                                            <Link to={`/product/${product._id}`}>
                                              {product?.name
                                                ?.split(" ")
                                                .slice(0, 7)
                                                .join(" ") + (product?.name?.split(" ").length > 7 ? "..." : "")}
                                            </Link>
                                          </h4>
                                          <div className="courseContent"
                                            dangerouslySetInnerHTML={{
                                              __html: product?.description
                                                ?.split(" ")
                                                .slice(0, 10)
                                                .join(" ") + (product?.description?.split(" ").length > 10 ? "..." : ""),
                                            }}
                                          ></div>
                                          <Link className='action btn btn-primary' to={`/product/${product._id}`}>
                                            <span>See Details</span>
                                          </Link>
                                        </div>
                                        {/*<div className="product-content backContent">
                                          <div
                                                                    dangerouslySetInnerHTML={{
                                                                      __html: product?.description
                                                                        ?.split(" ")
                                                                        .slice(0, 20)
                                                                        .join(" ") + (product?.description?.split(" ").length > 10 ? "..." : ""),
                                                                    }}
                                                                  ></div>
                                          <ul className='product-meta'>
                                            <li>
                                              <Link className='action' to={`/product/${product._id}`}>
                                                <span>See Details</span>
                                              </Link>
                                            </li>
                                          </ul>
                                        </div>*/}
                                      </div>
                                                </div>
                                                    </div>

                                                )
                                            
                                        })
                                    }
                                    
                                    {/*<!-- Single Product End -->*/}

                                </div>
                                </div>
                                </>
     )
        }
                                {/*<!-- Shop Product Wrapper End -->*/}

                            </div>

                        </div>

                        {/*<!-- Page pagination Start -->*/}
                        <div className="page-pagination">
                        {
                            count > resultPerPage  && (
                                    <Pagination
                                        activePage={currentPage}
                                        itemsCountPerPage={resultPerPage}
                                        totalItemsCount={count}
                                        onChange={setCurrentPageNo}
                                        nextPageText="Next"
                                        prevPageText="Prev"
                                        firstPageText="1st"
                                        lastPageText="Last"
                                        itemClass="page-item"
                                        linkClass="page-link"
                                        activeClass="active"
                                        activeLinkClass="active"
                                    />
                                )
                        }
                            
                        </div>
                        {/*<!-- Page pagination End -->*/}
                            
                       
                    </div>
                    <div className="col-lg-3">
                        {/*<!-- Sidebar Start -->*/}
                        <div className="sidebar">
                            
                            {/*<!-- Sidebar Widget Start -->*/}
                            {/*<div className="sidebar-widget">

                                <h4 className="widget-title">Filter By Categories</h4>

                                <div className="single-form widget-checkbox widget-categories">
                                    <ul className="checkbox-items">
                                
                                    {categories && categories.map((item) => (
                                        <li key={item._id} onClick={() => setCate(item?.name)}>
                                            <span className={`text-capitalize ${active == item?.name && 'active'}`} onClick={() => setActive(item?.name)}>{item?.name}</span>
                                        </li>
                                    ))}
                                        
                                    </ul>
                                <select 
                                    className="checkbox-select" 
                                    value={active} 
                                    onChange={(e) => {
                                        const selectedName = e.target.value;
                                        setCate(selectedName);
                                        setActive(selectedName);
                                    }}
                                >
                                    <option value="">
                                        Select a category
                                    </option>
                                    {categories && categories.map((item) => (
                                        <option key={item._id} value={item.name}>
                                            {item.name}
                                        </option>
                                    ))}
                                </select>

                                </div>
                            </div>*/}
                            {/*<!-- Sidebar Widget End -->*/}

                            {/*<!-- Sidebar Widget Start -->*/}
                            <div className="sidebar-widget">

                                <h4 className="widget-title">Filter By Speaker</h4>

                                <div className="single-form widget-checkbox widget-categories">
                                    
                                <select 
                                    className="checkbox-select" 
                                    value={activeSpeaker} 
                                    onChange={(e) => {
                                        const selectedName = e.target.value;
                                        setSpeaker(selectedName);
                                        setActiveSpeaker(selectedName);
                                    }}
                                >
                                    <option value="">
                                        Select a speaker
                                    </option>
                                    <option value="salman">Salman</option>
                                    <option value="hasnain">Hasnain</option>
                                    <option value="asad">Asad</option>
                                    {/*{products && 
                                        [...new Set(products.map((item) => item.speaker))].map((speaker, index) => (
                                            <option key={index} value={speaker}>
                                                {speaker}
                                            </option>
                                        ))
                                    }*/}
                                </select>

                                </div>
                            </div>
                            {/*<!-- Sidebar Widget End -->*/}
                            
                            {/*<!-- Sidebar Widget Start -->*/}
                            <div className="sidebar-widget">

                                <h4 className="widget-title">Filter By Price</h4>

                                <div className="widget-price">
                                    <Slider
                                      value={price}
                                      onChange={priceHandler}
                                      valueLabelDisplay="auto"
                                      aria-labelledby="range-slider"
                                      min={0}
                                      max={999}
                                    />
                                </div>

                                {/*<div className="widget-price">
                                    <input id="price-range" type="text"/>
                                </div>*/}
                            </div>
                            <div className="sidebar-widget">

                                <h4 className="widget-title">Filter By Range</h4>

                                <div className="widget-price">
                                    <Slider
                                      value={ratings}
                                      onChange={(e, newRating) => {setRatings(newRating);}}
                                      valueLabelDisplay="auto"
                                      aria-labelledby="continuous-slider"
                                      min={0}
                                      max={5}
                                    />
                                </div>

                                {/*<div className="widget-price">
                                    <input id="price-range" type="text"/>
                                </div>*/}
                            </div>
                            {/*<!-- Sidebar Widget End -->*/}
                            
                        </div>
                       {/* <!-- Sidebar End -->*/}
                    </div>
                    
                </div>
            </div>
            {/*<!-- Product Section Wrapper End -->*/}
        </div>
    </div>
    {/*<!-- Shop Section End -->*/}


        </>
    )
}

export default ShopByCate